import type { Converter } from "@/api/calls/backend-calls/converter-helpers"
import type { ValidEndpoints } from '@/api/clients/backend-client'
import type { DirectusManagedContent } from '@/types/directus-types'
import { fetchCollection } from './helper-functions'


type Managed_Content_Expected_API_DTO = {
  id: string
  name: string
  content: string
  description: string
  identifier: string
}

const managedContactConverter: Converter<Managed_Content_Expected_API_DTO, DirectusManagedContent> = {
  apiToLegacy(api){
    return {
      id: api.id,
      Name: api.name,
      Content: api.content,
      Description: api.identifier, // not descriptions are currently used as both an indication on what's this for and a unique identify. 
    }
  },
  legacyToApi(legacy) {
    return {
      id: legacy.id.toString(),
      content: legacy.Content,
      description: legacy.Description,
      name: legacy.Name,
      identifier: legacy.Description,
      // TODO: implement identifier to fix previous week unique description approach.
    }
  },
}

/** API Call to fetch managed content from DB. */
export async function fetchManagedContent(): Promise<DirectusManagedContent[] | undefined> {
  const collection: ValidEndpoints = 'managed_content'
  const res = await fetchCollection<Managed_Content_Expected_API_DTO, DirectusManagedContent>(
    collection,
    undefined,
    managedContactConverter.apiToLegacy
  )
  return res
}
